import Vue from 'vue'
import BpTabs from '../components/BpTabs'

const tabSections = [...document.querySelectorAll('.js-tabs')]

if (tabSections.length) {
    tabSections.forEach(function applyVueInstanceToTabs (el) {
        // eslint-disable-next-line no-new
        new Vue({
            el,
            components: {
                BpTabs,
            },
        })
    })
}
